const DEFAULT_API_BASE = 'https://ecommerce-clothing-backend.onrender.com';

export function normalizeApiBase(raw) {
  const fallback = DEFAULT_API_BASE;
  const trimmed = String(raw || '').trim();
  if (!trimmed) return fallback;

  let candidate = trimmed;
  if (!/^https?:\/\//i.test(candidate)) {
    candidate = `https://${candidate}`;
  }

  try {
    const url = new URL(candidate);
    return url.origin;
  } catch {
    return fallback;
  }
}

export function buildApiUrl(base, path, params) {
  const origin = normalizeApiBase(base);
  const pathname = path.startsWith('/') ? path : `/${path}`;
  const query = params?.toString();
  return `${origin}${pathname}${query ? `?${query}` : ''}`;
}

export async function fetchApiJson(url) {
  const res = await fetch(url);
  const contentType = res.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) {
    throw new Error(`API returned non-JSON response (${res.status})`);
  }
  const data = await res.json();
  if (!res.ok || !data.success) {
    throw new Error(data.error || `Request failed (${res.status})`);
  }
  return data;
}
